// @core/api/endpoints/document/register_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentRegistrationResponse,
  RegisterDocumentRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Register document
 * Registers a document in a formal registration journal. Assigns a registration number.
 */
export async function RegisterDocument(
  register_id: string,
  data: RegisterDocumentRequest,
  options?: RequestOptions
): Promise<DocumentRegistrationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-registers/:register_id/registrations`;
  requestPath = requestPath.replace(':register_id', encodeURIComponent(register_id));
  const requestOptions = options;
  return client.post<DocumentRegistrationResponse>(requestPath, data, requestOptions);
}
